import React, { Fragment, useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import Pagination from "react-js-pagination";
import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import { searchProperty, searchFromHash, setEncoded, getEncoded } from '../../../services/search'
import { bannerActionsAvailable } from './common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretUp, faCaretDown, faSort, faPencilAlt, faEye, faTrash, faSpinner, faShoppingCart } from '@fortawesome/free-solid-svg-icons'

import moment from "moment"

import useToastContext from "../../../hooks/useToastContext";

import { Helmet } from "react-helmet-async";

import { Modal } from '../../UI'

const ListTableHeader = ({ name, field, search, onSearch, setSearchProperty, inverseOrder }) => {
    const asc = inverseOrder ? 'desc' : 'asc'
    const desc = inverseOrder ? 'asc' : 'desc'
    return (
        <th
            className="cursor-pointer opacity-hover noselect text-nowrap"
            onClick={() => {
                const newDirection = (search.order && search.order.direction) ? (search.order.direction == asc ? desc : null) : asc
                onSearch(setSearchProperty('order', newDirection ? {
                    direction: newDirection,
                    by: field
                }: null))
            }}
        >
            <span>{name}</span>
            {(!search.order || (search.order.by != field)) &&
                <FontAwesomeIcon className="text-muted ms-2" icon={faSort} />
            }
            {search.order && search.order.by == field &&
                <span className="ms-2">
                    {search.order.direction == 'asc' && <FontAwesomeIcon icon={faCaretUp} />}
                    {search.order.direction == 'desc' && <FontAwesomeIcon icon={faCaretDown} />}
                </span>
            }
        </th>
    )
}

const ListItemActions = ({ item, modalDialog, loadList }) => {

    const { data, bannerServices } = useContext(AppContext)

    const [ deleteLoading, setDeleteLoading ] = useState(null)

    const { canEdit, canView, canDelete, linkToBuy } = bannerActionsAvailable(item, 'list')

    return (
        <Fragment>
            {canView &&
                <Link to={'/account/banner/view/' + item.id} className="me-2 text-nowrap">
                    <FontAwesomeIcon icon={faEye} />
                    <span className="ms-1 d-none d-xl-inline">View</span>
                </Link>
            }

            {canEdit &&
                <Link to={'/account/banner/edit/' + item.id} className="me-2 text-nowrap">
                    <FontAwesomeIcon icon={faPencilAlt} />
                    <span className="ms-1 d-none d-xl-inline">Edit</span>
                </Link>
            }

            {linkToBuy &&
                <Link to={'/account/banner/pay/' + item.id} className="me-2 text-nowrap text-success">
                    <FontAwesomeIcon icon={faShoppingCart} />
                    <span className="ms-1 d-none d-xl-inline">Order</span>
                </Link>
            }

            {canDelete &&
                <span
                    className={'cursor-pointer text-danger me-2 text-nowrap'}
                    disabled={deleteLoading == item.id}
                    title="Delete"
                    onClick={() => {
                        modalDialog({
                            title: 'Are you sure want to delete this draft?',
                            description: 'If you delete this banner ad, it cannot be undeleted.',
                            buttons: ['cancel', 'delete'],
                            type: 'danger'
                        }).then(() => {
                            setDeleteLoading(true)
                            bannerServices.delete(item.id).then(res => {
                                loadList()
                                setDeleteLoading(false)
                            }).catch(res => {
                                setDeleteLoading(false)
                            })
                        }).catch(res => {
                            console.log(res)
                        })
                    }}
                >
                    {deleteLoading == item.id && <FontAwesomeIcon icon={faSpinner} className="fa-spin" />}
                    {deleteLoading != item.id && <FontAwesomeIcon icon={faTrash} />}
                    <span className="ms-1 d-none d-xl-inline">Delete</span>
                </span>
            }
        </Fragment>
    )
}

const ListItem = ({ item, modalDialog, loadList }) => {
    return (
        <tr>
            <td
                className={
                    'text-left align-middle ' + (
                        item.status == 0 ? '' :
                        item.status == 1 ? 'table-secondary' :
                        item.status == 2 ? 'table-primary' :
                        item.status == 3 ? 'table-warning' :
                        item.status == 4 ? 'table-secondary' :
                        item.status == 5 ? 'table-success' : 'text-muted'
                    )
                }
            >
                {item.status == 0 && 'Draft'}
                {item.status == 1 && 'Under Review'}
                {item.status == 2 && 'Published'}
                {item.status == 3 && 'Rejected'}
                {item.status == 4 && 'Completed'}
                {item.status == 5 && 'Proccessing payment'}
            </td>
            <td className={ 'text-center align-middle ' + (item.can_be_shown ? 'table-success' : '') }>
                {item.can_be_shown ? 'Yes' : 'No'}
            </td>
            <td className={ 'text-center align-middle ' + (item.has_been_paid ? 'table-success' : '') }>
                {item.has_been_paid ? 'Yes' : 'No'}
            </td>
            <td className="text-left align-middle text-nowrap">
                <ListItemActions item={item} modalDialog={modalDialog} loadList={loadList} />
            </td>
            <td className="text-left align-middle">
                {item.human_title}<br />
                {item.placements &&
                    <div style={{lineHeight: '125%'}}>
                        {item.placements.map((item, i) => <small className="text-muted" key={item.id}>{i > 0 && <span>, </span>}{item.name}</small>)}
                    </div>
                }
            </td>
            <td className="text-center align-middle text-nowrap">
                <small>{moment(item.created_at).format('MM/DD/YY')}</small>
            </td>
            <td className="text-center align-middle text-nowrap">
                <small>{item.starts_at ? moment(item.starts_at).format('MM/DD/YY') : '—'}</small>
            </td>
            <td className="text-center align-middle text-nowrap">
                <small>{item.expires_at ? moment(item.expires_at).format('MM/DD/YY') : '—'}</small>
            </td>
            <td className="text-left align-middle">
                {item.clicks}
            </td>
            <td className="text-left align-middle">
                {item.views}
            </td>
            <td className="text-center align-middle">
                {item.id}
            </td>
        </tr>
    )
}

const ListTable = ({ list, search, setSearchProperty, onSearch, loadList, history }) => {

    const [ showDialog, setShowDialog ] = useState(false)
    const [ dialogOptions, setDialogOptions ] = useState({})

    const modalDialog = (options) => {
        return new Promise((resolve, reject) => {
            options.onButtonClick = button => {
                if(['cancel'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['close', 'ok'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['run'].includes(button)){
                    resolve()
                }
                if(['delete'].includes(button)){
                    setShowDialog(false)
                    resolve()
                }
            }
            options.size = 'md'
            options.show = showDialog
            setDialogOptions(options)
            setShowDialog(true)
        })
    }

    return (
        <div className="table-responsive">
            <Modal {...dialogOptions} show={showDialog} />
            <table className="table table-bordered table-hover bg-white">
                <thead className="thead-light">
                    <tr>
                        <ListTableHeader
                            name="Status"
                            field="status"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <ListTableHeader
                            name="Enabled"
                            field="can_be_shown"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <ListTableHeader
                            name="Paid"
                            field="has_been_paid"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <th>
                            <span>Manage</span>
                        </th>
                        <ListTableHeader
                            name="Name"
                            field="title"
                            search={name}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <ListTableHeader
                            name="Created at"
                            field="created_at"
                            search={search}
                            inverseOrder={true}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <ListTableHeader
                            name="Starts at"
                            field="starts_at"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <ListTableHeader
                            name="Expires in"
                            field="expires_at"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <ListTableHeader
                            name="Clicks"
                            field="clicks"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <ListTableHeader
                            name="Views"
                            field="views"
                            search={search}
                            onSearch={onSearch}
                            setSearchProperty={setSearchProperty}
                        />
                        <th className="text-nowrap text-center">ID</th>
                    </tr>
                </thead>
                <tbody>{list.data.map(item =>
                    <ListItem
                        key={item.id}
                        item={item}
                        loadList={loadList}
                        modalDialog={modalDialog}
                    />
                )}</tbody>
            </table>
        </div>
    )
}

const Index = ({ match, history }) => {

    const { data, location, bannerServices } = useContext(AppContext)
    const { app } = data
    const { user } = app

    const title = "Banner ads list"

    const [ loading, setLoading ] = useState(false)
    const [ banners, setBanners ] = useState({})

    const [ search, setSearch ] = useState({})
    const [ searchActive, setSearchActive ] = useState(false)

    const loadList = () => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            setSearch(searchFromHash())
            bannerServices.user(getEncoded()).then(res => {
                setBanners(res.banners)
                setLoading(false)
                setSearchActive(false)
                resolve()
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    useEffect(() => {
        loadList()
        const hashChangedHandle = () => loadList()
        window.addEventListener("hashchange", hashChangedHandle, false)
        return () => window.removeEventListener("hashchange", hashChangedHandle);
    }, [])

    const onSearch = newSearch => {
        setEncoded(newSearch ? newSearch : {... search})
    }

    const setSearchProperty = (type, value) => {
        const res = searchProperty(search, type, value)
        setSearch(res.search)
        if(!res.isEqual) setSearchActive(true)
        return res.search
    }

    const changePage = page => {
        setEncoded(setSearchProperty('page', page == 1 ? null : page))
    }


    return (
        <Fragment>
            <div>
                <Header history={history} fluid={true} />
                <main className="py-4">
                    <div className="container-fluid">

                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />

                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between">
                            <h1>{title}</h1>
                            <div><Link tag="a" className="btn btn-success" to="/account/banner/create">Create banner ad</Link></div>
                        </div>

                        <div>
                            {banners.data && !banners.data.length && <p>Banner ads list will be here. <Link tag="a" to="/account/banner/create">Create banner ad</Link>.</p>}
                            {banners.data && banners.data.length > 0 &&
                                <ListTable
                                    history={history}
                                    list={banners}
                                    search={search}
                                    onSearch={onSearch}
                                    loadList={loadList}
                                    setSearchProperty={setSearchProperty}
                                />
                            }
                            {banners.data && banners.data.length > 0 && banners.last_page > 1 &&
                                <nav>
                                    <Pagination
                                        activePage={search.page}
                                        itemsCountPerPage={parseInt(banners.per_page)}
                                        totalItemsCount={banners.total}
                                        pageRangeDisplayed={5}
                                        onChange={changePage}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        prevPageText="Previous"
                                        nextPageText="Next"
                                        hideFirstLastPages={true}
                                    />
                                </nav>
                            }
                        </div>

                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Index
